<ng-container *ngIf="datos.opcion == 'historial'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.TITULO' | translate}}</h2>
    <!-- <button mat-raised-button color="accent" (click)="abreModalImgHtml()">
      {{'EDITOR.ELEMENTOS.BOTONES.ADDIMG' | translate}}
      <mat-icon class="ml-20">add_a_photo</mat-icon>
    </button> -->
  </div>
  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="!historialRecuperado">
      <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
          <p>{{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.CARGANDO' | translate}}</p>
          <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="historialRecuperado">
      <ng-container *ngIf="historialCreacion.length > 0; else sinHistorial">
        <h3>
          <b>{{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.ULTIMA' | translate}}: </b>
          <em>{{historialCreacion[0].createdAt |date:"d MMM y H:mm" : datos.offsetPipe : datos.idiomaActual}} ({{historialCreacion[0].createdAt | date : 'O' : datos.offsetPipe : datos.idiomaActual}})</em>
        </h3>
        <mat-card class="mat-elevation-z4" *ngIf="historialCreacion.length > 2">
          <mat-card-header>
            <mat-card-subtitle>{{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.ANTERIORES' | translate}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-list>
              <ng-container *ngFor="let fecha of historialCreacion; let i = index; let last = last;">
                <ng-container *ngIf="i > 0">
                  <mat-list-item>{{fecha.createdAt |date:"d MMM y H:mm" : datos.offsetPipe : datos.idiomaActual}} ({{fecha.createdAt | date : 'O' : datos.offsetPipe : datos.idiomaActual}})</mat-list-item>
                  <mat-divider *ngIf="!last"></mat-divider>
                </ng-container>
              </ng-container>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </ng-container>
      <ng-template #sinHistorial>
        <h2>{{'SHEDULE2_0.CARDS.MODALGEN.HISTORIAL.NOHISTO' | translate}}</h2>
      </ng-template>
    </ng-container>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CARDS.MODALGEN.REGRESAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</ng-container>
<ng-container *ngIf="datos.opcion == 'certificado'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.MODALGEN.CERTIFICADO.TITULO' | translate}}</h2>
  </div>
  <mat-dialog-content class="mat-typography">
    <div fxLayout="column" fxLayoutAlign="start center">
      <div class="divCertificado noselect">
        <div class="contCertificado">
          <!-- <p class="watMark">SIN VALIDEZ OFICIAL</p>
          <br><br><br><br>
          <p class="titulo">Certificado</p>
          <img src="https://app04.culturalgo.com/assetsCGO5/logos/gptw.jpg" class="logo">
          <br><br>
          <p class="subtitulo">Great Place to Work® México</p>
          <p class="subtitulo">Certifica a:</p> -->
          <img [src]="datos.imagen" class="logoEmpresa2">
          <p class="textoAzul">{{datos.nombreEmpresa}}</p>
          <!-- <p>Por impulsar políticas y prácticas que mejoran la calidad de vida dentro de su organización y así cumplir con los requisitos </p>
          <p class="textAltAzul">XXXXXXX-XXXXXX</p>
          <p class="textAltRojo">Great Place to Work® México</p>
          <p> Dichos procesos de <span class="textoRojo">Great Place to Work® México</span> cumplen con la especificación XXXXX (Certificación de la metodología para ® calificar las condiciones del trabajo de las empresas) del <span class="textoRojo">Instituto Mexicano de Normalización y Certificación A.C.</span> </p>
          <div class="firmas">
            <div class="firma">
              <p>XXXXXX</p>
              <p>XXXXXX XXXXXXX</p>
            </div>
            <div class="firma">
              <p>XXXXXX</p>
              <p>XXXXXX XXXXXXX</p>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <img style="border:1px solid red" src="" width="90%">       -->
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button class="mt-20" (click)="salir()">
      {{'SHEDULE2_0.CARDS.MODALGEN.REGRESAR' | translate}}
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</ng-container>
